<ng-container *transloco="let t">
  <mat-form-field class="notes" appearance="fill" floatLabel="always">
    <mat-label>{{ t('inspection.fields.case:note') }}</mat-label>
    <textarea
      matInput
      name="notes"
      cdkTextareaAutosize
      [readonly]="readonly || printPreview"
      [formControl]="inputControl"
      [matAutocomplete]="auto"
      (focus)="onFocus()"
    ></textarea>
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngFor="let item of filteredOptions | async" [value]="item">
        <span>{{ item }}</span>
      </mat-option>
    </mat-autocomplete>
    <div matSuffix class="note-btns" *ngIf="!printPreview">
      <button
        mat-stroked-button
        color="primary"
        [disabled]="!inputControl.value"
        (click)="addNote($event)"
      >
        {{ t('inspection.fields.case:addNote') }}
      </button>
      <button
        mat-icon-button
        aria-label="notes-bank"
        color="primary"
        *ngIf="!(readonly || printPreview)"
        (click)="showNotesBank($event)"
      >
        <mat-icon>assignment</mat-icon>
      </button>
    </div>
  </mat-form-field>

  <ol
    *ngIf="notes?.length > 0"
    class="notes-list"
    cdkDropList
    (cdkDropListDropped)="drop($event)"
    cdkDragLockAxis="y"
    [style.margin-top]="!printPreview ? '-20px' : '10px'"
  >
    <label *ngIf="printPreview">{{
      t('inspection.fields.case:notesLabel')
    }}</label>
    <li
      *ngFor="let item of notes; let i = index"
      class="note-item"
      cdkDrag
      [cdkDragDisabled]="editableNoteIndex !== null || readonly || printPreview"
    >
      <span matLine class="note" *ngIf="i !== editableNoteIndex">
        <span class="text">{{ item.notes }}</span>
        <span class="spacer"></span>
        <div class="extra-params" *ngIf="!(readonly || printPreview)">
          <button
            mat-icon-button
            aria-label="add"
            color="primary"
            (click)="addSubNote(i)"
          >
            <mat-icon>add</mat-icon>
          </button>
          <button
            mat-icon-button
            aria-label="delete"
            color="primary"
            (click)="removeNote(i)"
          >
            <mat-icon>delete</mat-icon>
          </button>
          <button
            mat-icon-button
            aria-label="edit"
            color="primary"
            (click)="editNote(i)"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <mat-checkbox
            matSuffix
            [(ngModel)]="item.addNotesToReport"
            [disabled]="readonly"
            color="primary"
            class="report-note"
            (change)="onChange()"
          >
            {{ t('inspection.fields.case:attachToCertificate') }}
          </mat-checkbox>
        </div>
      </span>
      <span matLine class="note" *ngIf="i === editableNoteIndex">
        <textarea
          class="text input"
          authorityLabsAutofocus
          matInput
          cdkTextareaAutosize
          [(ngModel)]="item.notes"
        ></textarea>
        <span class="spacer"></span>
        <div class="extra-params">
          <button mat-stroked-button color="primary" (click)="applyChanges()">
            {{ t('inspection.fields.case:confirm') }}
          </button>
        </div>
      </span>
      <ol
        cdkDropList
        (cdkDropListDropped)="dropSubNotes(item, $event)"
        cdkDragLockAxis="y"
      >
        <li
          *ngFor="let subNote of item.subNotes; let ind = index"
          cdkDrag
          dense
        >
          <span matLine class="note" *ngIf="subNote !== editableSubNote">
            <span class="text"> {{ subNote.notes }}</span>
            <span class="spacer"></span>
            <div class="extra-params">
              <button
                mat-icon-button
                aria-label="delete-subnote"
                color="primary"
                (click)="removeSubNote(item, ind)"
              >
                <mat-icon>delete</mat-icon>
              </button>
              <button
                mat-icon-button
                aria-label="edit-subnote"
                color="primary"
                (click)="editSubNote(subNote)"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <mat-checkbox
                matSuffix
                [(ngModel)]="subNote.addNotesToReport"
                [disabled]="readonly"
                color="primary"
                class="report-note"
                (change)="onChange()"
              >
                {{ t('inspection.fields.case:attachToCertificate') }}
              </mat-checkbox>
            </div>
          </span>
          <span matLine class="note" *ngIf="subNote === editableSubNote">
            <textarea
              class="text input"
              authorityLabsAutofocus
              matInput
              cdkTextareaAutosize
              [(ngModel)]="subNote.notes"
            ></textarea>
            <span class="spacer"></span>
            <div class="extra-params">
              <button
                mat-stroked-button
                color="primary"
                (click)="applySubnoteChanges()"
              >
                {{ t('inspection.fields.case:confirm') }}
              </button>
            </div>
          </span>
        </li>
        <li *ngIf="addSubNoteToSummeryIndex === i">
          <span matLine class="note">
            <textarea
              class="text input"
              authorityLabsAutofocus
              matInput
              cdkTextareaAutosize
              [(ngModel)]="subNote"
            ></textarea>
            <span class="spacer"></span>
            <div class="extra-params">
              <button
                mat-stroked-button
                color="primary"
                (click)="saveSubNote(item)"
              >
                {{ t('inspection.fields.case:confirm') }}
              </button>
            </div>
          </span>
        </li>
      </ol>
    </li>
  </ol>
</ng-container>
